import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../index';
import { CanvasState } from '../../slices/canvas';

export const selectDisplayObjectOutlines = (): any =>
    createSelector(
        (state: RootState) => state.canvas,
        (canvas: CanvasState) => canvas.outlines.visible,
    );
